import { defineStore } from "pinia";

import environment from "@/environment";
import Crud from "@/store/crud";
import CountryData from "@/store/country-data";
import { loadStat } from "@/tools/chartLoadStat";

const crud = new Crud(
  environment.appConfig.baseApiUrl + "Analytics/top/domain/:projectId",
  "id",
  "",
  {}
);
const countryData = new CountryData();

export const useCountryStatDomainBlocksStore = defineStore({
  id: "countryStatDomainBlocks",
  state: () => ({
    ...crud.state,
    ...countryData.state,
  }),
  getters: {
    ...crud.getters,
    ...countryData.getters,
  },
  actions: {
    ...crud.actions,
    ...countryData.actions,
    loadStat,
  },
});
